/**
 * Client gate for extension ingest tokens UI (Story 2.4).
 * Mirrors backend EXTENSION_TOKENS_ENABLED — fail closed.
 * Never enable FE while backend flag is OFF.
 */

function parseEnvFlag(value) {
  return String(value || 'false').trim().toLowerCase() === 'true';
}

/**
 * @returns {boolean}
 */
export function isExtensionTokensUiEnabled() {
  return parseEnvFlag(process.env.REACT_APP_EXTENSION_TOKENS_ENABLED);
}

/**
 * Automatic extension handshake (AD-EA-5). Fail-closed, and meaningless without
 * REACT_APP_EXTENSION_TOKENS_ENABLED — the manual panel stays the fallback.
 * @returns {boolean}
 */
export function isExtensionAutoAuthEnabled() {
  return isExtensionTokensUiEnabled() && parseEnvFlag(process.env.REACT_APP_EXTENSION_AUTO_AUTH_ENABLED);
}

/**
 * Chrome extension id for externally_connectable handshake (Story 2.5).
 * @returns {string|null}
 */
export function getConfiguredExtensionId() {
  const id = String(process.env.REACT_APP_EXTENSION_ID || '').trim();
  return id || null;
}

/**
 * Stable device id for this browser (localStorage).
 * @returns {string}
 */
export function getOrCreateExtensionDeviceId() {
  const key = 'stacktrack_extension_device_id';
  try {
    const existing = localStorage.getItem(key);
    if (existing && existing.trim()) return existing.trim();
    const id = (typeof crypto !== 'undefined' && crypto.randomUUID)
      ? crypto.randomUUID()
      : `web-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    localStorage.setItem(key, id);
    return id;
  } catch {
    return `web-ephemeral-${Date.now()}`;
  }
}
